<template>
  <div>
    <d-card class="card-small">
      <!-- Card Header -->
      <d-card-header class="border-bottom">
        <h6 class="m-0">{{ title }}</h6>
        <div class="block-handle"></div>
      </d-card-header>

      <d-card-body class="p-0">
        <!-- Top Referrals List Group -->
        <d-list-group flush class="list-group-small" v-if="userPayments.length > 1">
          <d-list-group-item>
            <b-table
              id="my-table"
              :items="userPayments"
              :fields="column"
              :per-page="perPage"
              :current-page="currentPage"
            >
            </b-table>
          </d-list-group-item>
          <d-list-group-item>
            <b-pagination
              v-model="currentPage"
              :total-rows="rows"
              :per-page="perPage"
              aria-controls="my-table"
              @change="onPaginationClick()"
            ></b-pagination>
          </d-list-group-item>
        </d-list-group>
        <d-list-group v-else>
          <div class="row" style="margin: 10px">
            <div class="col">
              <h7 class="m-0">Төлбөрийн түүх олдсонгүй </h7>
           </div>
          </div>
        </d-list-group>
      </d-card-body>
    </d-card>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "payment-history",
  props: {
    /**
     * The component's title.
     */
    title: {
      type: String,
      default: "Төлбөрийн түүх",
    },
  },
  data() {
    return {
      perPage: 7,
      currentPage: 1,
      pageId: 1,
      column: [
        {
          key: "Id",
          label: "№",
        },
        {
          key: "Created",
          label: "Төрөл",
        },
        {
          key: "Total",
          label: "Дүн (₮)",
        },
        {
          key: "CreatedDate",
          label: "Огноо",
        },
        {
          key: "ServiceName",
          label: "Утга",
        },
      ],
    };
  },
  computed: {
    rows() {
      return this.userPayments.length;
    },
    userPayments() {
      return this.$store.getters.payments;
    },
  },
  methods: {
    onPaginationClick() {
      if ((this.rows / 20) <= this.pageId) {
        this.pageId++
        var configPayment = {
          method: "get",
          url: "https://mongolsat.mn/isat/contract/payments?page=" + this.pageId,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + this.$store.getters.userToken,
          },
        };

        axios(configPayment).then(
          (response) => {
            if (response.data != null && response.data.length > 0) {
              this.userPayments.push(response.data);
              this.$store.dispatch("retrievePayments", {
                payments: this.userPayments,
              });
            }
          },
          (error) => {
            console.log(error);
          }
        );     
      }
    },
  },
};
</script>
<style>
  .b-table{
    font-size: 14px;
  }
</style>